import type { Employee } from '@/types'

export const useEmployees = () => {
  function getColorClass(index: number): string {
    const colors = [
      'bg-[#39C0FE]',
      'bg-[#21BECB]',
      'bg-[#1AD194]',
      'bg-[#1AD126]',
      'bg-[#FFCE33]',
      'bg-[#FC9105]',
      'bg-[#FF5708]',
      'bg-[#FF1414]',
      'bg-[#D11A88]',
      'bg-[#A01AD1]',
      'bg-[#7939FE]',
      'bg-[#1A4BD1]',
      'bg-[#2180CF]'
    ]
    return colors[index % 13]
  }

  function shortName(name: string) {
    return name
      .split(' ')
      .map(n => Array.from(n)[0])
      .slice(0, 2)
      .join('')
  }

  function hasClockedIn(employee: Employee) {
    return Boolean(employee.clockIn) && !employee.clockOut
  }

  return {
    getColorClass,
    shortName,
    hasClockedIn
  }
}
